import { defineStore } from "pinia";
import { useCsrfStore } from "@/stores/csrf";
import { queryString } from "@/helpers";
export const useDashboard = defineStore("dashboard", {
    state: () => ({
        stats: undefined,
        heatmap: undefined
    }),
    actions: {
        async fetchStats(starts, ends, orgFilter) {
            const { fetch } = useCsrfStore();
            this.stats = await fetch("GET")(`dashboard${queryString({
                starts: starts ? starts.toISOString() : undefined,
                ends: ends ? ends.toISOString() : undefined,
                org: orgFilter ?? undefined,
            })}`);
            return this.stats;
        },
        async fetchHeatmap(starts, ends, orgFilter) {
            const { fetch } = useCsrfStore();
            this.heatmap = await fetch("GET")(`dashboard/heatmap${queryString({
                starts: starts ? starts.toISOString() : undefined,
                ends: ends ? ends.toISOString() : undefined,
                org: orgFilter ?? undefined,
            })}`);
            return this.heatmap;
        }
    },
});
